import script from "./BillDentitionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BillDentitionModal.vue?vue&type=script&setup=true&lang=js"

import "./BillDentitionModal.vue?vue&type=style&index=0&id=239a715e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239a715e"]])

export default __exports__